import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import "./rankingStyle.css";

export default function LoveRanking({ profileId, isOwner }) {
  const { user } = useSelector((state) => ({ ...state }));
  const [ranking, setRanking] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showRanking, setShowRanking] = useState(false);
  const [assigningBadge, setAssigningBadge] = useState(null);

  const fetchRanking = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/profiles/${profileId}/love/ranking`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      setRanking(data.ranking);
      setShowRanking(true);
    } catch (error) {
      console.error("Erro ao carregar ranking:", error);
      if (error.response?.status === 403) {
        alert("Você não tem permissão para visualizar este ranking");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleAssignBadge = async (userId, badge) => {
    try {
      setAssigningBadge(`${userId}-${badge}`);
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/profiles/${profileId}/love/badges`,
        { userId, badge },
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      // Recarregar ranking
      fetchRanking();
    } catch (error) {
      console.error("Erro ao atribuir badge:", error);
      alert("Erro ao atribuir badge");
    } finally {
      setAssigningBadge(null);
    }
  };

  const handleRemoveBadge = async (userId, badge) => {
    try {
      setAssigningBadge(`${userId}-remove`);
      await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/profiles/${profileId}/love/badges`,
        {
          data: { userId, badge },
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      // Recarregar ranking
      fetchRanking();
    } catch (error) {
      console.error("Erro ao remover badge:", error);
      alert("Erro ao remover badge");
    } finally {
      setAssigningBadge(null);
    }
  };

  const getBadgeLabel = (badge) => {
    const labels = {
      "top-fan": "🏆 Top Fã",
      "super-fan": "⭐ Super Fã",
      "mega-fan": "👑 Mega Fã",
    };
    return labels[badge] || badge;
  };

  if (!isOwner) return null;

  return (
    <div className="love_ranking_container">
      <button
        className="view_ranking_btn"
        onClick={() => (showRanking ? setShowRanking(false) : fetchRanking())}
        disabled={loading}
      >
        <span>❤️</span>
        {showRanking ? "Ocultar Ranking" : "Ver Ranking de Fãs"}
      </button>

      {showRanking && ranking.length > 0 && (
        <div className="ranking_modal_overlay">
          <div className="ranking_modal">
            <div className="ranking_header">
              <h2>🏆 Ranking de Fãs</h2>
              <button
                className="close_btn"
                onClick={() => setShowRanking(false)}
              >
                ✕
              </button>
            </div>

            <div className="ranking_list">
              {ranking.map((item, index) => (
                <div key={item.user.id} className="ranking_item">
                  <div className="ranking_position">
                    {index === 0 && <span className="medal">🥇</span>}
                    {index === 1 && <span className="medal">🥈</span>}
                    {index === 2 && <span className="medal">🥉</span>}
                    {index > 2 && <span className="position_number">#{index + 1}</span>}
                  </div>

                  <img
                    src={item.user.picture}
                    alt={item.user.name}
                    className="user_avatar"
                  />

                  <div className="user_info">
                    <div className="user_name">{item.user.name}</div>
                    <div className="user_username">@{item.user.username}</div>
                    <div className="click_count">
                      {item.clickCount} {item.clickCount === 1 ? "clique" : "cliques"}
                    </div>
                  </div>

                  <div className="badges_section">
                    {item.badges.map((badge) => (
                      <div key={badge} className="badge">
                        <span>{getBadgeLabel(badge)}</span>
                        <button
                          className="remove_badge_btn"
                          onClick={() => handleRemoveBadge(item.user.id, badge)}
                          disabled={assigningBadge === `${item.user.id}-remove`}
                          title="Remover distintivo"
                        >
                          ✕
                        </button>
                      </div>
                    ))}

                    {item.badges.length === 0 && (
                      <div className="no_badges">Sem distintivos</div>
                    )}
                  </div>

                  <div className="assign_badge_section">
                    <button
                      className="badge_btn top-fan"
                      onClick={() => handleAssignBadge(item.user.id, "top-fan")}
                      disabled={assigningBadge === `${item.user.id}-top-fan`}
                      title="Atribuir Top Fã"
                    >
                      🏆
                    </button>
                    <button
                      className="badge_btn super-fan"
                      onClick={() => handleAssignBadge(item.user.id, "super-fan")}
                      disabled={assigningBadge === `${item.user.id}-super-fan`}
                      title="Atribuir Super Fã"
                    >
                      ⭐
                    </button>
                    <button
                      className="badge_btn mega-fan"
                      onClick={() => handleAssignBadge(item.user.id, "mega-fan")}
                      disabled={assigningBadge === `${item.user.id}-mega-fan`}
                      title="Atribuir Mega Fã"
                    >
                      👑
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {showRanking && ranking.length === 0 && (
        <div className="empty_ranking">
          <p>Nenhum amor registrado ainda 💔</p>
        </div>
      )}
    </div>
  );
}
